import { LockIcon } from 'lucide-react';
import { useParams } from 'react-router';
import { EmptyState } from '@/components/EmptyState';
import { useMe } from '@/lib/auth';
import { jobReportsApi } from '@/lib/reports';
import { useJob } from '@/features/jobs/queries';
import { ReportsPanel } from './ReportsPanel';

/** Job → Reports: digests and notices scoped to this job, for its admins. */
export function JobReportsPage() {
  const { jobId = '' } = useParams<{ jobId: string }>();
  const me = useMe();
  const job = me.jobs.find((j) => j.id === jobId);
  const detail = useJob(jobId);
  const isAdmin = me.user.tenantRole === 'org_admin' || job?.myRole === 'admin';
  if (!isAdmin) return <EmptyState icon={LockIcon} title="Reports are for job admins" description="Ask a PM Admin or Super User if you want a report for this job. Reports sent to you show up in your inbox on this page." />;
  const timezone = detail.data?.job.timezone ?? me.tenant.quietHours?.timezone ?? null;
  return (
    <div className="space-y-6">
      <p className="text-muted-foreground text-sm">Weekly digests, delivery alerts, opt-outs and sign-ups for {job?.name ?? 'this job'}. Organization-wide reports live under Organization → Reports.</p>
      <ReportsPanel api={jobReportsApi(jobId)} queryKey={['reports', 'job', jobId]} scope="job" jobId={jobId} jobs={job ? [{ id: job.id, name: job.name, timezone }] : []} defaultTimezone={timezone} />
    </div>
  );
}
